function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.1961 23.1792C16.3186 23.3017 16.4778 23.4119 16.6371 23.4732C16.6494 23.4732 16.6494 23.4732 16.6616 23.4854C16.8209 23.5467 16.9801 23.5835 17.1517 23.5835C17.3232 23.5835 17.4947 23.5467 17.6417 23.4854C17.654 23.4854 17.654 23.4854 17.6662 23.4732C17.8377 23.3997 17.9847 23.3017 18.1073 23.1792L25.4824 15.804C26.0092 15.2772 26.0092 14.4196 25.4824 13.8928C24.9556 13.366 24.0981 13.366 23.5713 13.8928L18.5115 18.9525V1.35988C18.5115 0.612557 17.9112 0 17.1517 0C16.3921 0 15.7918 0.600306 15.7918 1.35988V18.9525L10.7321 13.8928C10.2053 13.366 9.34768 13.366 8.82088 13.8928C8.29408 14.4196 8.29408 15.2772 8.82088 15.804L16.1961 23.1792Z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.9433 20.9862C32.196 20.9862 31.5835 21.5865 31.5835 22.3461C31.5835 26.1684 28.4717 29.2802 24.6493 29.2802H9.6539C5.83155 29.2802 2.71975 26.1684 2.71975 22.3461C2.71975 21.5988 2.11945 20.9862 1.35988 20.9862C0.600306 20.9862 0 21.5988 0 22.3461C0 27.6631 4.32466 32 9.6539 32H24.6616C29.9786 32 34.3155 27.6753 34.3155 22.3461C34.3032 21.5988 33.7029 20.9862 32.9433 20.9862Z",
  fill: "current"
}));

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.3bfb905d.svg";
export { ForwardRef as ReactComponent };